import React, { useState } from 'react';
import styled from 'styled-components';
import { dateToShow } from '@helpers/utils';
import { moneyFormat } from '@helpers';
import { Tooltip, theme, Icon, Modal } from 'fpay-ui';
import { TextoFpay } from 'components/Modal/ModalAndTooltip';
import { useTranslation } from 'react-i18next';
import { MenuItem } from '@material-ui/core';
import { Menu } from '@components/Menu';
import { useAuth } from '@hooks';
import { TransactionsDetailModalMobile } from '@components';
import { useDispatch } from 'react-redux';
import { clearTransactionDetails } from 'redux/transactions/actions';

const IconInfo = styled(Icon)`
  margin-left: 5px;
  display: flex;
`;

const Card = styled.div`
  display: flex;
  width: 100%;
  background-color: #fff;
  border-radius: 6px;
  padding-top: 14px;
  padding-bottom: 14px;
  padding-left: 10px;
  padding-right: 10px;
  flex-direction: row;
  margin-bottom: 8px;
`;

const CardRow = styled.div`
  width: 100%;
  display: flex;
  margin-bottom: ${(props) => (props.top ? '22px' : '')};
`;

const CardItemLeft = styled.div`
  display: flex;
  width: 40%;
  flex-direction: column;
`;
const CardItemRight = styled.div`
  display: flex;
  width: 60%;
  flex-direction: column;
`;

const TitleLeft = styled.div`
  display: flex;
  width: 100%;
  font-size: 12px;
  font-weight: 500;
  color: #a2a7ba;
  line-height: 14px;
  justify-content: flex-start;
  margin-bottom: 4px;
  margin-top: 1px;
`;

const TitleRight = styled.div`
  display: flex;
  width: 100%;
  font-size: 12px;
  font-weight: 500;
  color: #a2a7ba;
  line-height: 14px;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 3px;
`;

const DatoLeft = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-start;
  color: #444b62;
  font-size: 12px;
`;

const DatoRightAlone = styled(DatoLeft)`
  justify-content: flex-end;
`;

const DatoRight = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  font-size: 12px;
  color: #444b62;
  font-weight: 600;
`;

const ColumnData = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
`;
const ColumnDots = styled.div`
  width: 12px;
  justify-content: flex-end;
  padding-left: 2px;
  margin-top: -1px;
`;

const CardFalabella = ({ item, key }) => {
  const { t } = useTranslation();

  const [showModalMobile, setShowModalMobile] = useState(false);
  const [headerData, setHeaderData] = useState(null);

  const dispatch = useDispatch();

  const handleGetTransactionDetails = (orderData) => {
    setHeaderData(orderData);
    setShowModalMobile(true);
  };

  const { isAllowed } = useAuth();

  const showOptionForDetails = isAllowed('FALABELLA_TRANSACTIONS_DETAILS');

  const handleCloseDetails = () => {
    dispatch(clearTransactionDetails());
    setShowModalMobile(false);
  };

  return (
    <>
      <Card key={key}>
        <ColumnData>
          <CardRow top>
            <CardItemLeft>
              <TitleLeft>{t('transactionsFalabella.cardCod')}</TitleLeft>
              <DatoLeft>{item.authorization_id}</DatoLeft>
            </CardItemLeft>
            <CardItemRight>
              <TitleRight>
                <Tooltip position="bottom" duration={100} width="190px">
                  <IconInfo
                    icon="tooltip-info"
                    width="16px"
                    height="16px"
                    color={`${theme.colors.gray500}`}
                  />
                  <TextoFpay>{t('transactionsFalabella.tableTooltipText')}</TextoFpay>
                </Tooltip>
                <div style={{ paddingLeft: '4px' }}>{t('transactionsFalabella.cardRef')}</div>
              </TitleRight>
              <DatoRight>
                {item.details_transaction?.reference_number
                  ? item.details_transaction.reference_number
                  : '-'}
              </DatoRight>
            </CardItemRight>
          </CardRow>
          <CardRow>
            <CardItemLeft>
              <DatoLeft>{dateToShow(item.event_date)}</DatoLeft>
            </CardItemLeft>
            <CardItemRight>
              <DatoRightAlone>{moneyFormat(item.gross_value)}</DatoRightAlone>
            </CardItemRight>
          </CardRow>
        </ColumnData>
        {showOptionForDetails && item.details_transaction?.reference_number && (
          <ColumnDots>
            <Menu
              icon="ic_menu_dots.svg"
              dataTestId="menu-dots"
              imageStyle={{ width: '18px', height: '18px' }}
            >
              <MenuItem
                id="qe-detalle-devolucion"
                data-testid="qe-detalle-devolucion_detalle"
                onClick={() => handleGetTransactionDetails(item)}
              >
                Detalle
              </MenuItem>
            </Menu>
          </ColumnDots>
        )}
      </Card>
      {showModalMobile && (
        <Modal
          fClose={handleCloseDetails}
          width="370px"
          borderRadius="16px"
          htmlIdClose="transactions-see-detail-close"
          htmlIdBackground="transactions-see-detail-close-bkgd"
        >
          <TransactionsDetailModalMobile
            handleCloseError={handleCloseDetails}
            headerData={headerData}
          />
        </Modal>
      )}
    </>
  );
};

export default CardFalabella;
